import React, { useState } from 'react';
import { Box, ThemeProvider, createTheme } from "@mui/material";
import Footer from "../footer/page";
import FloatingAgentBubble from "./components/FloatingAgentBubble";

import EcosystemHero from "./components/EcosystemHero";
import TheProblemSolution from "./components/TheProblemSolution";
import EcosystemBentoGrid from "./components/EcosystemBentoGrid";
import BusinessFunnel from "./components/BusinessFunnel";
import ProfessionalFunnel from "./components/ProfessionalFunnel";
import SynergySection from "./components/SynergySection";
import MetricsAndTrust from "./components/MetricsAndTrust";
import MissionVisionValues from "./components/MissionVisionValues";
import LeadershipTeam from "./components/LeadershipTeam";
import UnifiedCTA from "./components/UnifiedCTA";

// Crear un tema premium oscuro para la página principal
const darkPremiumTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#6C4DE2',
    },
    secondary: {
      main: '#F21C63',
    },
    background: {
      default: '#0B0914',
      paper: '#13111C',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const Home = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 = Empresas, 1 = Profesionales

  return (
    <ThemeProvider theme={darkPremiumTheme}>
      <Box sx={{ overflow: "hidden", bgcolor: 'background.default' }}>
        {/* 1. Hero del Ecosistema (Con Tabs de Empresa/Profesional) */}
        <EcosystemHero activeTab={activeTab} setActiveTab={setActiveTab} />

        {/* 2. Agitación del problema y presentación de Hitpoly como la Solución */}
        <TheProblemSolution activeTab={activeTab} />

        {/* 3. Bento Grid de Herramientas (Detallado y Popups adaptado) */}
        <EcosystemBentoGrid activeTab={activeTab} />

        {/* 4. Embudos Condicionales y Completos */}
        {activeTab === 0 ? <BusinessFunnel /> : <ProfessionalFunnel />}

        {/* 5. Sección de Sinergia (Colaboración) */}
        <SynergySection activeTab={activeTab} />

        {/* 6. Métricas y Resultados */}
        <MetricsAndTrust activeTab={activeTab} />

        {/* 7. Misión, Visión y Valores */}
        <MissionVisionValues />

        {/* 8. Equipo de Liderazgo */}
        <LeadershipTeam />

        {/* 9. CTA Unificado */}
        <UnifiedCTA activeTab={activeTab} />

        {/* Footer */}
        <Footer />

        {/* Botón flotante estilo burbuja de Asesor IA */}
        <FloatingAgentBubble />
      </Box>
    </ThemeProvider>
  );
};

export default Home;
